<script lang="ts">
  interface Props {
    size?: number;
    [key: string]: any;
  }

  let { size = 16, ...rest }: Props = $props();
</script>

<svg
  width={size}
  height={size}
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  {...rest}
>
  <path
    d="M4.75 9.09766C5.77806 9.36255 6.59075 10.1566 6.88184 11.1738C7.94679 10.9922 8.93779 10.486 9.71191 9.71191C10.486 8.93779 10.9922 7.94679 11.1738 6.88184C9.91913 6.52281 9 5.37002 9 4C9 2.34315 10.3431 1 12 1C13.6569 1 15 2.34315 15 4C15 5.42106 14.0112 6.60796 12.6846 6.91797C12.4854 8.36911 11.8209 9.72602 10.7734 10.7734C9.72602 11.8209 8.36911 12.4854 6.91797 12.6846C6.60796 14.0112 5.42106 15 4 15C2.34315 15 1 13.6569 1 12C1 10.6024 1.95646 9.43095 3.25 9.09766V1H4.75V9.09766ZM4 10.5C3.17157 10.5 2.5 11.1716 2.5 12C2.5 12.8284 3.17157 13.5 4 13.5C4.82843 13.5 5.5 12.8284 5.5 12C5.5 11.1716 4.82843 10.5 4 10.5ZM12 2.5C11.1716 2.5 10.5 3.17157 10.5 4C10.5 4.82843 11.1716 5.5 12 5.5C12.8284 5.5 13.5 4.82843 13.5 4C13.5 3.17157 12.8284 2.5 12 2.5Z"
    fill="currentColor"
  />
</svg>
